"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.destroy = destroy;
var _sendMessage = require("../send-message");
var _context = require("../context");
/*
* Copyright (c) 2020 Wells Fargo, All rights reserved.
*
* This software is the confidential and proprietary information of Wells Fargo
* bank. ('Confidential Information'). You shall not disclose such Confidential
* Information and shall use it only in accordance with the terms of the license
* agreement you entered into with WellsFargo.
*/

/**
 * Destroy Iframe Comment
 * - destroys the iframe
 *
 * @module core-bootstrap-command-destroy
 */

/**
 * Destroy the SDK and remove the iframe
 *
 * @param {string} id The UUID of the target iframe for this command
 */
function destroy(id) {
  var iframeEntry = (0, _context.getIframeConfiguration)(id);
  if (!iframeEntry) {
    return;
  }
  (0, _sendMessage.sendMessage)('destroy', {}, id);

  // remove iframe DOM element
  try {
    iframeEntry.element.parentNode.removeChild(iframeEntry.element);
  } catch (e) {
    // parent DOM removed the SDK iframe already
  }

  // remove iframe configuration
  (0, _context.getContext)().iframes = (0, _context.getContext)().iframes.filter(function (value) {
    return value.id !== id;
  });
}
//# sourceMappingURL=destroy.js.map